import { styled } from '@mui/material/styles';
import { ArrowDownIcon } from 'assets/images/icons';
import { BRAND_TEAL } from '@constants/colors';

export const MenuTinyArrow = styled(ArrowDownIcon, { shouldForwardProp: prop => prop !== 'isUp' })(({ isUp }) => ({
    width: 4,
    marginLeft: 6,
    '& path': {
        fill: BRAND_TEAL,
        fillOpacity: 1,
    },
    ...(isUp && {
        transform: 'rotate(180deg)',
    }),
}));
